export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const SET_NOTIFICATION_READ = 'SET_NOTIFICATION_READ';
